import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as S from "./FollowUp.style";
import OutcomesTabs from "../aiNavigator/components/outcomesTabs";
import ZaiaImage from "../../zaiaComponents/zaiaImage";
import { useTranslation } from "react-i18next";
import Popup from "reactjs-popup";
import ZaiaInput from "../../zaiaComponents/zaiaInput";
import UserAINavigatorBoxes from "../aiNavigator/components/modalUserAiNavigator/userAINavigatorView";
import Modal from "../../../utils/modal";
import ZaiaModalResponseContent from "../../zaiaComponents/zaiaModalResponseContent";
import { useStateValue } from "../../../contextAPI/StateProvider";
import * as P from '../../../utils/pipes'
import ZaiaReaction from "../../zaiaComponents/zaiaReaction";
import { MUTATION_UPDATE_USER_TO_PROCESS_FOLLOW_UP } from "../../../graphql/mutations/UserToProcess";
import { useMutation, useQuery, useSubscription } from "@apollo/client";
import { SUBSCRIPTION_GET_USER_TO_PROCESS_BY_ISACEPTED_AND_ID } from "../../../graphql/subscriptions/UserToProcess";
import useRecordNavigation from "../../../hooks/useRecordNavigation";
import { Actions } from "../../../utils/actionsIds";
import ModalAddOutcomesEvent from "../shared/modals/modalAddOutcomesEvent";
import { QUERY_GET_USER_TO_PROCESS_HISTORY_AND_CALL_NOTE, QUERY_GET_USER_TO_PROCESS_HISTORY_BY_PATIENT } from "../../../graphql/queries/UserToProcessHistory";
import NoteHistory from "../notesView/components/noteHistory/NoteHistory";
import NoteForm from "../notesView/components/noteForm";
import NoteComplete from "../notesView/components/noteComplete";
import ListNotes from "../notesView/components/listNotes/ListNotes";
import { QUERY_GET_USER_BY_ID } from "../../../graphql/queries/User";
import FlorenzButton from "../../florenzComponents/florenzButton";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../../utils/constants";
import FlorenzSelect from "../../florenzComponents/florenzSelect/FlorenzSelect";
import FollowUpCall from "./followUpCall/FollowUpCall";
import useDoctorData from "../../../hooks/useDoctorData";
import { useTwilioClient } from "../../../hooks/useTwilioClient";
import { SUBSCRIPTION_GET_USER_TO_PROCESS_HISTORY_AND_CALL_NOTE, SUBSCRIPTION_GET_USER_TO_PROCESS_HISTORY_BY_PATIENT } from "../../../graphql/subscriptions/UserToProccesHistory";

const eventsCalendarEmpty = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/list-events-empty.svg`;
const ENV = process.env.REACT_APP_ENV;

function FollowUp({}){

  const {t, i18n: { language }} = useTranslation("global");
  const [noteSelected, setNoteSelected] = useState(false);
  const [createNoteActived, setCreateNoteActived] = useState(false);
  const [editNoteActived, setEditNoteActived] = useState(false);
  const [historyActived, setHistoryActived] = useState(false);
  const navigate = useNavigate();
  const { AINAVIGATOR, DASHBOARD, AGENDA, CHAT } = Routes;
  const [seeMoreOptions, setSeeMoreOptions] = useState(false);
  const [historyCalls, setHistoryCalls] = useState(false);
  const [phoneStartCall, setPhoneStartCall] = useState(null);
  const {doctorData} = useDoctorData();
  const now = useMemo(() => new Date(), []);

  const [speakerDevices, setSpeakerDevices] = useState([]);
  const [microphoneDevices, setMicrophoneDevices] = useState([]);
  const [selectedSpeaker, setSelectedSpeaker] = useState("");
  const [selectedMicrophone, setSelectedMicrophone] = useState("");

  const twilioClient = useTwilioClient();

  const [userToProcessLastCallHistory, setUserToProcessLastCallHistory] = useState(null);
  const [lastCallId, setLastCallId] = useState(null);
  const [lastCallIdToSave, setLastCallIdToSave] = useState(null);

  useSubscription(
    SUBSCRIPTION_GET_USER_TO_PROCESS_HISTORY_AND_CALL_NOTE,
    {
      onData: ({data: {data}}) => {       
        const callIdTemp = data.call?.[0].id;        
        if(!userToProcessLastCallHistory || (callIdTemp !== userToProcessLastCallHistory?.callId)) {
          setLastCallId(callIdTemp);
        }
      }
    }
  );  

  useEffect(() => {
    if (twilioClient.callStatus === "open") {
      setLastCallIdToSave(lastCallId)
    }
  }, [twilioClient]);

  // Cargar dispositivos de audio
  useEffect(() => {
    async function loadDevices() {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();

        setSpeakerDevices(devices.filter((d) => d.kind === "audiooutput"));
        setMicrophoneDevices(devices.filter((d) => d.kind === "audioinput"));

        if (devices.some((d) => d.kind === "audiooutput")) {
          setSelectedSpeaker(devices.find((d) => d.kind === "audiooutput").deviceId);
        }
        if (devices.some((d) => d.kind === "audioinput")) {
          setSelectedMicrophone(devices.find((d) => d.kind === "audioinput").deviceId);
        }
      } catch (err) {
        console.error("Error al obtener dispositivos:", err);
      }
    }

    loadDevices();
  }, []);

  const selectSpeaker = (e) => {    
    setSelectedSpeaker(e);
    twilioClient.updateSpeakerDevice(e);
  }

  const selectMicrophone = (e) => {
    setSelectedMicrophone(e);
    twilioClient.updateRingtoneDevice(e);
  }  



  const states = useMemo(() => [
    {
      id: 1,
      key: "next",
      name: t("followUp.due"),
      color: "#09BB5B",
      backgroungColor: "#FBFFFD",
      buttonColor: "#36369B",
    },
    {
      id: 2,
      key: "now",
      name: t("globally.today"),
      color: "#0B8FEE",
      backgroungColor: "#F7FAFF",
      buttonColor: "#0B8FEE",
    },
    {
      id: 3,
      key: "past",
      name: t("followUp.next"),
      color: "#DB5454",
      backgroungColor: "#FFFDFD",
      buttonColor: "#36369B",
    },
  ], [t]);

  

  const getState = useCallback((date) => {
    if (!date) return states.find(state => state.key === "now");

    if (
      date.getDate() === now.getDate() &&
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear()
    ) {
      return states.find(state => state.key === "now");
    } else if (date > now) {
      return states.find(state => state.key === "next");
    } else {
      return states.find(state => state.key === "past");
    }
  }, [states, now]);

  const [{
    followUpActive
  }] = useStateValue();
  const { recordAction } = useRecordNavigation();

  const [followUpUserToProcessId, setFollowUpUserToProcessId] = useState(null);

  useEffect(() => {
    if (followUpActive) {
      setFollowUpUserToProcessId(followUpActive.id);
    }
  }, [followUpActive]);

  const { data: userToProcessData, error: userToProcessError, loading: userToProcessLoading } = useSubscription(SUBSCRIPTION_GET_USER_TO_PROCESS_BY_ISACEPTED_AND_ID, {
    variables: { 
      isAcepted: true,
      userToProcessId: followUpUserToProcessId
    },
  });

  const [{followUpMinimized}, dispatch] = useStateValue();

  const [viewTab, setViewTab] = useState(1);
  const [dirtyModal, setDirtyModal] = useState(false);
  const [activeCloseModal, setActiveCloseModal] = useState(false);
  const [description, setDescription] = useState("");
  const [descriptionWarning, setDescriptionWarning] = useState(false);
  const [activeSuccessModal, setActiveSuccessModal] = useState(false);

  const frequency = () => {
    if(userToProcessData?.userToProcess[0].processStage?.frequencyType === "days") {
      return (
        `${userToProcessData?.userToProcess[0].processStage?.frequency > 1 ? userToProcessData?.userToProcess[0].processStage?.frequency : ""}
        ${userToProcessData?.userToProcess[0].processStage?.frequency > 1 ? t("globally.days") : t("globally.day")}`
      ) 
    } else if(userToProcessData?.userToProcess[0].processStage?.frequencyType === "months") {
      return (
        `${userToProcessData?.userToProcess[0].processStage?.frequency > 1 ? userToProcessData?.userToProcess[0].processStage?.frequency : ""}
        ${userToProcessData?.userToProcess[0].processStage?.frequency > 1 ? t("globally.months") : t("globally.month")}`
      ) 
    } else {
      return (`${userToProcessData?.userToProcess[0].processStage?.frequency}`)
    }
  } 

  const frequencyHours = useCallback((date) => {
    const frequency = userToProcessData?.userToProcess[0].processStage?.frequency;
    const frequencyType = userToProcessData?.userToProcess[0].processStage?.frequencyType;

    if (frequencyType === "days") {
      return frequency * 24;
    } else if (frequencyType === "months") {
      const firstDate = new Date(date);
      const calc = Math.abs(
        new Date(firstDate.getFullYear(), firstDate.getMonth() + frequency, firstDate.getDate()) - firstDate
      );
      const days = Math.ceil(calc / (1000 * 60 * 60 * 24));
      return days * 24;
    } else {
      return frequency;
    }
  }, [userToProcessData]);

  const daysRemaining = (date) => {    
    const dateNow = new Date(Date.now());
    const daysRemaining = Math.floor((date?.setHours(0,0,0,0) - dateNow.setHours(0,0,0,0)) / (1000 * 60 * 60 * 24));
    return Math.abs(daysRemaining)
  }

  const [tabs, setTabs] = useState(
    [
      {
        id: 1,
        // icon: "zaia-dashboard",
        name: t("followUp.followUpManagement"),
        description: t("followUp.followUpManagementDescription")
      },
      {
        id: 2,
        // icon: "zaia-dashboard",
        name: t("globally.ainavigator"),
        description: t("followUp.ainavigatorDescription")
      },
    ]
  )

  const patientOptions = [
    {
      id: 1,
      text: "Ir a sección de salud del paciente",
      view: `${AINAVIGATOR.route}/${userToProcessData?.userToProcess[0].user.id}`,
      action: () => recordAction(Actions.FOLLOW_UP.GO_TO_HEALTH),
      icon: "zaia-i-hearth",
      color: "#FA5ACA"
    },
    {
      id: 2,
      text: "Ir a sección de reportes del paciente",
      view: `${DASHBOARD.route}`,
      action: () => recordAction(Actions.FOLLOW_UP.GO_TO_REPORTS),
      icon: "zaia-i-flag",
      color: "#E6575E"
    },
    {
      id: 3,
      text: "Ir a agenda del paciente",
      view: `${AGENDA.route}`,
      action: () => recordAction(Actions.FOLLOW_UP.GO_TO_AGENDA),
      icon: "zaia-i-calendar-2",
      color: "#FAB031"
    },
    {
      id: 4,
      text: "Chat",
      view: `${CHAT.route}`,
      action: () => recordAction(Actions.FOLLOW_UP.GO_TO_CHAT),
      icon: "zaia-i-message-outline",
      color: "#0C0AA2"
    }
  ]

  const setFollowUpMinimized = (active) => {
    dispatch({
      type: "SET_FOLLOWUP_MINIMIZED",
      followUpMinimized: active,
    });
  }

  const closeModalConfirmation = () => {
    return (
      <S.FollowUpModalClose>
        <div className="modal-background" onClick={() => setActiveCloseModal(false)}>
        </div>
        <div className="content">
          <ZaiaModalResponseContent
            button1={() => closeModal()}
            button2={() => setActiveCloseModal(false)}
            formSuccess={false}
            button1Text={t("followUp.confirm")}
            button2Text={t("globally.cancel")}
            title={t("followUp.closeManagement")}
            subtitle={t("followUp.closeManagementSub")}
            doubleButton={true}
          />
        </div>
      </S.FollowUpModalClose>
    )
  }

  const successFollowUpCompletedModal = () => {
    return (
      <S.FollowUpModalClose>
        <div className="modal-background" onClick={() => setActiveSuccessModal(false)}>
        </div>
        <div className="content">
          <ZaiaModalResponseContent
            button1={() => setActiveSuccessModal(false)}
            formSuccess={true}
            button1Text={t("globally.done")}
            title={t("followUp.followUpCompleted")}
            doubleButton={false}
          />
        </div>
      </S.FollowUpModalClose>
    )
  }

  const closeModalConfirm = () => {
    if(dirtyModal) {
      setActiveCloseModal(true);
    } else {
      closeModal();
    }
  }

  const closeModal = () => {
    dispatch({
      type: "SET_SELECTED_PATIENT",
      selectedPatient:  null
    });
    dispatch({
      type: "SET_FOLLOWUP_ACTIVE",
      followUpActive: false,
    });
    dispatch({
      type: "SET_FOLLOWUP_MINIMIZED",
      followUpMinimized: true,
    });
  } 

  const followUpInfo = useMemo(() => {
    if (!userToProcessData) return [];
    return [
      {
        id: userToProcessData.userToProcess[0].id,
        processId: userToProcessData.userToProcess[0].process?.id,
        processName: P.dataTranslation(userToProcessData.userToProcess[0].process?.processName, language),
        stageId: userToProcessData.userToProcess[0].stageId,
        lastFollowingDate: userToProcessData.userToProcess[0].userToProcessHistories[0]
          ? new Date(userToProcessData.userToProcess[0].userToProcessHistories[0].created_at)
          : null,
        nextFollowingDate: new Date(userToProcessData.userToProcess[0].nextUpdate),
        futureFollowingDate: new Date(
          new Date(userToProcessData.userToProcess[0].nextUpdate).setHours(
            frequencyHours(userToProcessData.userToProcess[0].nextUpdate), 0, 0, 0
          )
        )
      }
    ];
  }, [userToProcessData, language, frequencyHours]);

  const optionAction = (view, action) => {
    setFollowUpMinimized(true);
    navigate(view);
    recordAction(action);
  }

  const nextUpdateDate = useMemo(() => {
    return userToProcessData?.userToProcess[0].nextUpdate 
      ? new Date(new Date(userToProcessData?.userToProcess[0].nextUpdate).setHours(frequencyHours(userToProcessData?.userToProcess[0].nextUpdate),0,0,0))
      : new Date(new Date(Date.now()).setHours(frequencyHours(Date.now()),0,0,0))
  }, 
  [userToProcessData]);

  const callCondition = useMemo(() => {           

    return (
      userToProcessData?.userToProcess[0].user.phone ||         
      userToProcessData?.userToProcess[0].user.phoneCarer
    ) && 
    (
      ENV === "development" || (
        ENV === "production" && 
        (
          userToProcessData?.userToProcess[0].process.id === 73 ||
          userToProcessData?.userToProcess[0].process.id === 50
        )
      )
    )
  }, [userToProcessData])

  const selectPhoneInfo = ({
    number,
    countryCode,
    label,
    name
  }) => {
    const phoneInfo = {
      number,
      countryCode,
      label,
      name
    }
    setPhoneStartCall(phoneInfo);
  }

  return (
    <S.FollowUp
      viewTab={viewTab}
      descriptionWarning={descriptionWarning}
      state={getState(userToProcessData?.userToProcess[0].nextUpdate
        ? new Date(userToProcessData?.userToProcess[0].nextUpdate)
        : new Date(Date.now()))}
      callActive={phoneStartCall}
    >
      <Modal open={activeCloseModal}>
        {closeModalConfirmation()}
      </Modal>
      <Modal open={activeSuccessModal}>
        {successFollowUpCompletedModal()}
      </Modal>
      {
        followUpMinimized &&  
        <div className="minimized">
          <div className="header-minimized">
            <button 
              className="option-button" 
              onClick={() => {
                recordAction(Actions.FOLLOW_UP.CLOSE);
                closeModalConfirm();
              }}
            >
              <i className="option-button__icon icon zaia-icono-cerrar" />
            </button>
            <button className="option-button"
              onClick={
                () => {
                  recordAction(Actions.FOLLOW_UP.MAXIMIZE);
                  setFollowUpMinimized(false);
                }
              }
            >
              <i className="option-button__icon icon zaia-i-up"></i>
            </button>
            <div className="header__title">
              {t("followUp.followUpManagement")}
            </div>  
          </div>
          <div className="patient-info">
            <img className="patient-info__img-patient" src={userToProcessData?.userToProcess[0].user.picture} alt="F" />
            <div className="patient-info__name">{userToProcessData?.userToProcess[0].user.name + " " + userToProcessData?.userToProcess[0].user.lastname}</div>
          </div>
        </div>
      }
      {
        !followUpMinimized &&
        <div className="big-screen">
          <div className="header-big-screen">
            <div className="more-options">
              <Popup
                trigger={() => (
                  <div className="more-options__trigger">
                    <FlorenzButton
                      typeStyle={"secondaryWhite"}
                      size="s"
                      text={t("followUp.moreOptions")}
                      widthComplete={true}
                    />
                  </div>
                )}
                // on={["hover"]}
                keepTooltipInside
                position="bottom"
              >
                {() => (
                  <S.MoreOptionsPopup>
                    <div className="header">
                      <div className="header__title">{t("followUp.moreOptions")}</div>
                    </div>
                    <div className="buttons-sections">
                      {
                        patientOptions.map((option) => (
                          <div className="button-action"
                            key={option.text}
                            onClick={
                              () => {
                                optionAction(option.view, option.action);
                              }
                            }
                          >
                            <div className="button-action__text">
                              {option.text}
                            </div>
                            <div 
                              className={`button-action__icon ${option.icon}`}
                              style={{color: option.color}}
                            ></div>
                          </div>
                        ))
                      }
                      {/* <div className="more-options"
                        onClick={() => setSeeMoreOptions(!seeMoreOptions)}
                      >
                        <div className="see-more__label">
                          ~See more 
                        </div>
                        <div className="see-more__button">
                          <button className="see-more">
                            <i className={
                              `icon ${
                                seeMoreOptions
                                ? "zaia-i-down"
                                : "zaia-i-up"
                              }`
                            }/>
                          </button>
                        </div>
                      </div> */}
                      {
                        seeMoreOptions &&
                        <div className="more-options-content">
                        </div>
                      }
                    </div>
                  </S.MoreOptionsPopup>
                )}
              </Popup>
              
            </div>
            <div className="buttons">
              <button 
                className="option-button" 
                onClick={
                  () => {
                    closeModalConfirm();
                    recordAction(Actions.FOLLOW_UP.CLOSE);
                  }
                }
              >
                <i className="option-button__icon icon zaia-icono-cerrar" />
              </button>
              <button 
                className="option-button" 
                onClick={
                  () => {
                    setFollowUpMinimized(true);
                    recordAction(Actions.FOLLOW_UP.MINIMIZE);
                  }
                }
              >
                <i className="option-button__icon option-button__icon--minimize icon zaia-i-down"></i>
                {/* <div className="option-button__text">
                  {t("globally.minimize")} 
                </div> */}
              </button>
            </div>
            {/* <div className="tabs">
              <OutcomesTabs
                setViewTab={setViewTab}
                viewTab={viewTab}
                tabs={tabs}
              />
            </div>   */}
          </div>
          <div className="content">
            <div className="content__left">
              <div className="patient-card"
                style={{
                  display: phoneStartCall ? "flex" : "none"
                }}  
              >
                <FollowUpCall
                  userPicture={userToProcessData?.userToProcess[0].user.picture}
                  phoneStartCall={phoneStartCall}
                  setPhoneStartCall={setPhoneStartCall}
                  patient={userToProcessData?.userToProcess[0].user}
                  doctor={doctorData}
                  userToProcess={userToProcessData?.userToProcess[0]}
                  twilioClient={twilioClient}
                  speakerDevices={speakerDevices}
                  microphoneDevices={microphoneDevices}
                  selectedSpeaker={selectedSpeaker}
                  selectedMicrophone={selectedMicrophone}
                  setSelectedSpeaker={setSelectedSpeaker}
                  setSelectedMicrophone={setSelectedMicrophone}
                />
              </div>
              <div className="patient-card"
                style={{
                  display: phoneStartCall ? "none" : "flex" 
                }}
              >
                <div className="patient-card__info">
                  <div className="patient-image">
                    <ZaiaImage
                      img={userToProcessData?.userToProcess[0].user.picture}
                      rounded={true}
                      size={118}
                    />
                  </div>
                  <div className="patient-info">
                    {
                      userToProcessData 
                      ? (
                        <>
                          <Popup
                            trigger={() => (
                              <div
                                className="patient-info__name"
                              >
                                {userToProcessData?.userToProcess[0].user.name + " " + userToProcessData?.userToProcess[0].user.lastname}
                              </div>
                            )}
                            on={["hover"]}
                            position="top center"
                          >
                            {() => (
                              <S.PatientNamePopup>
                                {userToProcessData?.userToProcess[0].user.name + " " + userToProcessData?.userToProcess[0].user.lastname}
                              </S.PatientNamePopup>
                            )}
                          </Popup>

                        </>
                      )
                      : null
                    }
                    <div className="patient-info__program">
                      {
                        <Popup
                          trigger={
                            <div className="patient-info__program-detail">
                              {/* {
                                patient?.userToProcesses.length > 1 
                                ? <div style={{"textDecoration": "underline"}}>{t("globally.variousProcesses")}</div> : 
                                <div>{P.dataTranslation(patient?.userToProcesses[0].process?.processName, language)}</div>
                                
                              } */}
                              {P.dataTranslation(userToProcessData?.userToProcess[0].process?.processName, language)}
                            </div>
                          }
                          keepTooltipInside
                          nested
                          // position={"right bottom"}
                          on="hover"
                          // disabled={patient?.userToProcesses.length > 1 ? false : true}
                        >
                          {
                            // <ProcessName userToProcesses={patient?.userToProcesses}/>
                          }
                        </Popup>
                      }
                      
                    </div>
                    <div className="patient-info__email">{userToProcessData?.userToProcess[0].user.email}</div>
                    <div className="patient-info__fequency">
                      {t("globally.frequency")}: <b>{t("globally.each")} {frequency()}</b>
                    </div>
                  </div>
                </div>
                {
                  callCondition &&
                  <div className="patient-card__right">
                    <div className="calls-info">
                      {/* <div className="calls-info__left">
                        <div className="calls-info__text">
                          ~Total de llamadas al paciente:
                        </div>
                        <div className="calls-info__text">
                          <b>15 horas al mes</b>
                        </div>
                      </div>
                      <div className="calls-info__right">
                        <div className="calls-info__text">
                          Tiempo restante: <b>3 h 20 min</b>
                        </div>        
                        <div className="calls-info__text">
                          Llamadas restantes: 3
                        </div>
                      </div> */}
                    </div>
                    <div className="bar-container">
                      <div className="bar">
                        <div className="bar__progress"
                          style={{width: "70%"}}
                        ></div>
                      </div>
                    </div>
                    <div className="select-container">
                      {
                        twilioClient.twilioClientInitialized &&
                        <>
                          <Popup
                            trigger={
                              // <div className="input">
                              //   <div className="input__text">
                              //     {
                              //       customInitialDateRange && customFinishDateRange 
                              //         ? `${P.shortDate(customInitialDateRange, t, true, language)} - ${P.shortDate(customFinishDateRange, t, true, language)}` 
                              //         : rangeSelected?.text
                              //     }
                              //   </div>
                              //   <i className="input__icon icon zaia-icono-dropdown-light"></i>
                              // </div>
                              <div>
                                <FlorenzSelect
                                  placeholder={t("followUp.call")}
                                  xsSize={true} 
                                  forWhiteBackgroud={true}
                                  required
                                  noDropdown

                                />   
                              </div>
                            }
                            position="bottom center"
                            closeOnDocumentClick
                          >
                            {
                              close => (
                                <S.PopUpitems>
                                  <div className="number"
                                    onClick={() => {
                                      selectPhoneInfo({
                                        number: userToProcessData?.userToProcess[0].user.phone,
                                        countryCode: `${userToProcessData?.userToProcess[0].user?.phoneCountry?.phonecode}`,
                                        name: userToProcessData?.userToProcess[0].user.nameCarer + " " + userToProcessData?.userToProcess[0].user.lastnameCarer,
                                      })
                                      close();
                                    }}
                                  >
                                    <div className="number__text">
                                      {`+${userToProcessData?.userToProcess[0].user?.phoneCountry?.phonecode} ${userToProcessData?.userToProcess[0].user.phone} (${t("globally.patient")})`}
                                    </div>
                                    <i className="number__icon icon zaia-i-phone"></i>
                                  </div>
                                  {
                                    userToProcessData?.userToProcess[0].user.phoneCarer && (
                                      <div className="number"
                                        onClick={() => {
                                          selectPhoneInfo({
                                            number: userToProcessData?.userToProcess[0].user.phoneCarer,
                                            countryCode: `${userToProcessData?.userToProcess[0].user?.carerPhoneCountry?.phonecode}`,
                                            label: "Caregiver",
                                            name: userToProcessData?.userToProcess[0].user.nameCarer + " " + userToProcessData?.userToProcess[0].user.lastnameCarer,
                                          })
                                          close();
                                        }}
                                      >
                                        <div className="number__text">
                                          {`+${userToProcessData?.userToProcess[0].user?.carerPhoneCountry?.phonecode} ${userToProcessData?.userToProcess[0].user.phoneCarer} (${t("globally.caregiver")})`}
                                        </div>
                                        <i className="number__icon icon zaia-i-phone"></i>
                                      </div>
                                    )
                                  }
                                </S.PopUpitems>
                              )
                            }
                          </Popup>
                          <Popup
                            trigger={
                              <button className="call-button">
                                <i className="call-button__icon icon zaia-i-manage-account"></i> 
                              </button>
                            }
                            keepTooltipInside
                            nested
                            position={"center bottom"}
                            on="click"
                            
                          >
                            <S.CallSettings>
                              <div className="header">
                                <i className="header__icon icon zaia-i-filters"></i>
                                <div className="header__text">
                                  {t("followUp.callSettings")}
                                </div>
                              </div>
                              <div className="selects">
                                <div className="select">
                                  <FlorenzSelect 
                                    label={t("followUp.audio")}
                                    xsSize={true}
                                    forWhiteBackgroud={true}
                                    items={
                                      speakerDevices.map((device) => (
                                        {
                                          value: device.deviceId || t("followUp.speakerWithoutName"),
                                          text: device.label || t("followUp.speakerWithoutName")
                                        }
                                      ))
                                    }
                                    value={selectedSpeaker}
                                    setValue={selectSpeaker}
                                  />
                                </div>
                                <div className="select">
                                  <FlorenzSelect 
                                    label={t("followUp.microphone")}
                                    xsSize={true}
                                    forWhiteBackgroud={true}
                                    items={
                                      microphoneDevices.map((device) => (
                                        {
                                          value: device.deviceId || t("followUp.microphoneWithoutName"),
                                          text: device.label || t("followUp.microphoneWithoutName")
                                        }
                                      ))
                                    }
                                    value={selectedMicrophone}
                                    setValue={selectMicrophone}
                                  />
                                </div>
                              </div>
                            </S.CallSettings>
                          </Popup>
                        </>
                      }
                    </div>
                  </div>
                }
                {/* {
                  callCondition &&
                  <div className="patient-card__right">
                    <div className="numbers">
                      <div className="numbers__title">
                        <div className="numbers__title-text">{t("aiNavigator.patientModal.phoneNumbers")}</div>
                        <i className="numbers__title-icon icon zaia-i-phone"></i>
                      </div>
                      <div className="number">
                        <div className="number__title">
                          {t("globally.patient")}
                        </div>
                        <div className="number__phone">
                          {userToProcessData?.userToProcess[0].user.phone}
                        </div>
                      </div>
                      {
                        userToProcessData?.userToProcess[0].user.phoneCarer &&
                        <div className="number">
                          <div className="number__title">
                            {t("globally.caregiver")}
                          </div>
                          <div className="number__phone">
                            {userToProcessData?.userToProcess[0].user.phoneCarer}
                          </div>
                        </div>
                      }
                    </div> 
                  </div> 
                } */}
              </div>
              <div className="principal-content"
                style={
                  viewTab === 2
                  ? {
                    backgroundColor: "transparent"
                  }
                  : {
                    backgroundColor: "#FFF"
                  }
                } 
              >
                {
                  viewTab === 2
                  ? <UserAINavigatorBoxes
                    followUpInfo={followUpInfo}
                    patient={userToProcessData?.userToProcess[0].user}
                    followUpMinimizeFunc={setFollowUpMinimized}
                    closeModal={setFollowUpMinimized}
                  />
                  : <>
                      {/* <div className="add-comment">

                        <div className="add-comment__msg">
                          {t("followUp.commentDescription")}
                        </div>
                        
                      </div> */}
                      {
                        userToProcessData &&
                        <div className="card-list">
                          <FollowUpCard
                            date={
                              userToProcessData?.userToProcess[0].nextUpdate
                              ? new Date(userToProcessData?.userToProcess[0].nextUpdate)
                              : new Date(Date.now())
                            }
                            titleCard={t("followUp.nextFollowUp")}
                            changeDateButton={true}
                            description={description}
                            setDescription={setDescription}
                            frequency={frequency}
                            descriptionWarning={descriptionWarning}
                            setDescriptionWarning={setDescriptionWarning}
                            setDirtyModal={setDirtyModal}
                            setActiveSuccessModal={setActiveSuccessModal}
                            comment={true}
                            outcomesFillingOption={userToProcessData?.userToProcess[0].process?.id === 47 || userToProcessData?.userToProcess[0].process?.id === 65}
                            selectedPatient={userToProcessData?.userToProcess[0].user}
                            processSelected={userToProcessData?.userToProcess[0].process?.id}
                            state={getState(userToProcessData?.userToProcess[0].nextUpdate
                              ? new Date(userToProcessData?.userToProcess[0].nextUpdate)
                              : new Date(Date.now()))}
                            daysRemaining={daysRemaining}
                            lastCallId={lastCallIdToSave}
                          />
                          <div className="future-follow-up">
                            <div className="future-follow-up__label">
                              {t("followUp.futureFollowUp")}
                            </div>
                            <div className="future-follow-up__date">
                              {
                                P.longDate(
                                  nextUpdateDate,
                                  t,
                                  language
                                )
                              }
                            </div>
                            <div className="future-follow-up__days-remaining">
                              {
                                daysRemaining(nextUpdateDate) > 0 &&
                                <div className="card-info__status-large">
                                  {daysRemaining(nextUpdateDate)} {
                                    getState(nextUpdateDate)?.key === "next" 
                                    ? daysRemaining(nextUpdateDate) > 1
                                      ? t("followUp.daysLeft")
                                      : t("followUp.dayLeft")
                                    : daysRemaining(nextUpdateDate) > 1
                                      ? t("followUp.daysLate")
                                      : t("followUp.dayLate")
                                  }
                                </div>
                              }
                            </div>
                          </div>
                          {/* <FollowUpCard
                            date={
                              userToProcessData?.userToProcess[0].nextUpdate 
                              ? new Date(new Date(userToProcessData?.userToProcess[0].nextUpdate).setHours(frequencyHours(userToProcessData?.userToProcess[0].nextUpdate),0,0,0))
                              : new Date(new Date(Date.now()).setHours(frequencyHours(Date.now()),0,0,0))
                            }
                            titleCard={t("followUp.futureFollowUp")}
                            changeDateButton={false}
                          /> */}
                        </div>
                      }
                    </>
                }
              </div>
            </div>
            <div className="content__right">
              <div className="title">
                <div className="title__text">{t("globally.history")}</div>
                <i className="title__icon icon zaia-timeline"></i>
              </div>
              <div className="subtitle">{t("followUp.historySubtitle")}</div>
              <div className="comments-list">
                <NotesContent
                  setCreateNoteActived={setCreateNoteActived}
                  createNoteActived={createNoteActived}
                  noteSelected={noteSelected}
                  setNoteSelected={setNoteSelected}
                  editNoteActived={editNoteActived} 
                  setEditNoteActived={setEditNoteActived}
                  historyActived={historyActived}
                  setHistoryActived={setHistoryActived}
                  patientSelected={userToProcessData?.userToProcess[0].user}
                  processSelected={userToProcessData?.userToProcess[0].process}
                  setUserToProcessLastCallHistory={setUserToProcessLastCallHistory}
                />
              </div>
              {/* <div className="comments-list">
                <div className="comments-list__last-follow-up-text">{t("followUp.lastFollowUp")}</div>
                {
                  userToProcessData?.userToProcess[0].userToProcessHistories.filter((history) => history.descript).map(
                    (history, index) => {
                      return (
                        <div key={history.id}>
                          <div className="comment-card">
                            <div className="comment-card__time">
                              <div className="comment-card__date">
                              {P.shortDate(history.created_at, t, true, language)}
                              </div>
                              <div className="comment-card__hour">
                                {P.hoursIn12format(new Date(history.created_at).getHours(), new Date(history.created_at).getMinutes())}
                              </div>
                            </div>
                            <div className="comment-card__text">
                              {history.descript}
                            </div>
                          </div>
                          {
                            index === 0 && userToProcessData?.userToProcess[0].userToProcessHistories.length > 1 && <div className="last-comment-separator"></div>
                          }
                        </div>
                      )
                    }
                  )
                }
                {
                  userToProcessData?.userToProcess[0].userToProcessHistories.filter((history) => history.descript).length === 0 &&
                  <ZaiaReaction
                    zaiaImg={eventsCalendarEmpty}
                    text={t("followUp.noCommentsYet")}
                    // subText={}
                    sizeText="30px"
                    sizeSubText="15px"
                    textColor="var(--blue-color)"
                    widthimg="250px"
                  />
                }
              </div> */}
            </div>
          </div>
        </div>
      }
    </S.FollowUp>
  );
}

const NotesContent = ({
  setCreateNoteActived,
  createNoteActived,
  noteSelected,
  setNoteSelected,
  patientSelected,
  editNoteActived,
  setEditNoteActived,
  historyActived,
  setHistoryActived,
  processSelected,
  setUserToProcessLastCallHistory
}) => {

  const {t, i18n: { language }} = useTranslation("global");

  const [formNoteText, setFormNoteText] = useState("");
  const [userToProcessSelected, setUserToProcessSelected] = useState(null);

  const {
    data: userToProcessHistory,
    loading: userToProcessHistoryLoading,
    error: userToProcessHistoryError
  } = useSubscription(SUBSCRIPTION_GET_USER_TO_PROCESS_HISTORY_BY_PATIENT, {
    variables: {
      patientId: patientSelected?.id
    },
    skip: !patientSelected,
  });    

  useEffect(() => {
    if(userToProcessHistory) {
      const userToProcessItemTemp = userToProcessHistory?.userToProcessHistory.filter(userToProcessHistory => userToProcessHistory.descript && userToProcessHistory.callId)?.[0];      
      setUserToProcessLastCallHistory(userToProcessItemTemp);
    }
  }, [userToProcessHistory])
  
  if(patientSelected) {
    if(historyActived) {
      return <NoteHistory
        listNotes={userToProcessHistory?.userToProcessHistory.filter(userToProcessHistory => userToProcessHistory.descript)}
        setCreateNoteActived={setCreateNoteActived}
        createNoteActived={createNoteActived}
        noteSelected={noteSelected}
        setNoteSelected={setNoteSelected}
        setEditNoteActived={setEditNoteActived}
        patientSelected={patientSelected}
        historyActived={historyActived}
        setHistoryActived={setHistoryActived}
      />
    } else if(createNoteActived || editNoteActived) {
      return <NoteForm
        setCreateNoteActived={setCreateNoteActived}
        editNoteActived={editNoteActived}
        setEditNoteActived={setEditNoteActived}
        patientSelected={patientSelected}
        formNoteText={formNoteText}
        setFormNoteText={setFormNoteText}
        userToProcessSelected={userToProcessSelected}
        setUserToProcessSelected={setUserToProcessSelected}
      />
    } else {
      if(noteSelected) {
        return <NoteComplete
          setNoteSelected={setNoteSelected}
          noteSelected={noteSelected}
          setEditNoteActived={setEditNoteActived}
        />
      } else {
        return <ListNotes
          listNotes={userToProcessHistory?.userToProcessHistory.filter(userToProcessHistory => userToProcessHistory.descript)}
          setCreateNoteActived={setCreateNoteActived}
          createNoteActived={createNoteActived}
          noteSelected={noteSelected}
          setNoteSelected={setNoteSelected}
          setEditNoteActived={setEditNoteActived}
          patientSelected={patientSelected}
          historyActived={historyActived}
          setHistoryActived={setHistoryActived}
          programIdSelected={processSelected.id}
        />
      }
    }
  }
   
    
  
}

function FollowUpCard({
  titleCard,
  date,
  changeDateButton,
  description,
  setDescription,
  frequency,
  setDescriptionWarning,
  setDirtyModal,
  setActiveSuccessModal,
  comment,
  outcomesFillingOption,
  selectedPatient,
  processSelected,
  state,
  daysRemaining,
  lastCallId
}) {

  const {t, i18n: { language }} = useTranslation("global");
  const [buttonActive, setButtonActive] = useState(true);
  const [updateUserToProcess, {loading: updateUserToProcessLoading, error: updateUserToProcessError}] = useMutation(MUTATION_UPDATE_USER_TO_PROCESS_FOLLOW_UP);
  const [changeDateActive, setChangeDateActive] = useState(false);
  const [newDate, setNewDate] = useState(P.formatNumberDateInput(date));
  const [addOutcomesEvent, setAddOutcomesEvent] = useState(false);
  const [commentOnly, setCommentOnly] = useState(outcomesFillingOption ? false : true);

  const handleKeyUp = (e, msg) => {
    if(e.target.scrollHeight !== 22) {
      e.target.style.height = 'inherit';
      e.target.style.height = `${e.target.scrollHeight}px`; 
    }
    if(msg === ""){
      e.target.style.height = '22px';
    }
  }

  
  const [{
    followUpActive
   }, dispatch] = useStateValue();

  const markAsCompleted = async () => {
    console.log("que passoooooo");
    
    if(description.trim() !== "") {
      setDescriptionWarning(false);
      try {
        await updateUserToProcess({
          variables: {
            updates: {
              descript: description,
              isChecked: true,
              callId: lastCallId
            },
            userToProcessId: followUpActive.id
          }, 
        });
        setDescription("");
        setButtonActive(false);
        setDirtyModal(false);
        setActiveSuccessModal(true);
        dispatch({
          type: "SET_FOLLOWUP_NEEDS_UPDATE",
          followUpNeedsUpdate: true
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      setDescriptionWarning(true);
    }
  }

  const changeNextUpdate = async () => {
    const nextUpdateDate = new Date(new Date(newDate).getTime() + new Date(newDate).getTimezoneOffset() * 60000);

    if(P.formatNumberDateInput(date) !== newDate) {
      try {
        const 
          data
        = await updateUserToProcess({
          variables: {
            updates: {
              nextUpdate: nextUpdateDate
            },
            userToProcessId: followUpActive.id
          },
        });
        console.log(data);
        setChangeDateActive(false);
        dispatch({
          type: "SET_FOLLOWUP_NEEDS_UPDATE",
          followUpNeedsUpdate: true
        });
      } catch (error) {
        console.log(error);
      } 
    } else {
      setChangeDateActive(false);
    }
  }  
  
  return (
    <S.FollowUpCard
      color={state?.color}
      backgroungColor={state?.backgroungColor}
      buttonColor={state?.buttonColor}
    >
      <Modal open={addOutcomesEvent}>
        <ModalAddOutcomesEvent                  
          setCreateEventActive={setAddOutcomesEvent}
          patientID={selectedPatient?.id}
          processID={processSelected}
          followUpChecked={true}
        />
      </Modal>
      {/* <div className="status">{state.title}</div> */}
      <div className="status">
        <div className="status__left">
          <div className="status__top">
            <div className="status__text">
              {titleCard}
            </div>
            <div className="status__days-remaining">
              {
                daysRemaining(date) > 0 &&
                <div className="card-info__status-large">
                  {daysRemaining(date)} {
                    state?.key === "next" 
                    ? daysRemaining(date) > 1
                      ? t("followUp.daysLeft")
                      : t("followUp.dayLeft")
                    : daysRemaining(date) > 1
                      ? t("followUp.daysLate")
                      : t("followUp.dayLate")
                  }
                </div>
              }
            </div>
          </div>
          <div className="status__bottom">
            {
              !changeDateActive &&
              <>
                <div className="status__date">{P.longDate(date, t, language)}</div>
                {
                  changeDateButton &&
                  <div className="status__date-change" onClick={() => setChangeDateActive(true)}>
                    {t("globally.changeDate")}
                    <i className="status__date-change-icon icon zaia-i-refresh"></i>
                  </div>
                }
              </>
            }
          </div>
        </div>
        {
          outcomesFillingOption &&
          <div className="status__outcomes-tabs">
            <div className="tabs">
              <div className={`tab ${ commentOnly && "tab--selected"}`}
                onClick={() => setCommentOnly(true)}
              >{t("followUp.fillOutcomesTabComment")}</div>
              <div className={`tab ${ !commentOnly && "tab--selected"}`}
                onClick={() => setCommentOnly(false)}
              >{t("followUp.fillOutcomesTabOutcomes")}</div>
            </div>
          </div>
        }
      </div>
      {
        !changeDateActive && 
        <div className="card-content">
          {
            !commentOnly &&
            <div className="outcomes-button-container">
              <div className="outcomes-button-container__title">{t("followUp.aboutOutcomes")}</div>
              <div className="outcomes-button-container__description">
                {t("followUp.aboutOutcomesSub")}
              </div>
              <div className="button-outcomes"
                onClick={() => setAddOutcomesEvent(true)}
              >
                <button className="fill-outcomes">
                  <div className="fill-outcomes__text">{t("followUp.fillOutcomes")}</div>
                  <i className="fill-outcomes__icon icon zaia-i-next"></i>
                </button>
              </div>
            </div>
            
          }
          {
            comment && commentOnly &&
            <div className="add-comment">
              <div className="add-comment__label">
                {t("globally.details")}
                {
                  description === "" ? <p className="required">*</p> : <i className="icon zaia-i-check-1"></i>
                }
                
              </div>
              <ZaiaInput
                placeholder={t("followUp.addComment")}
                textarea
                value={description}
                getText={(e) => {
                  if(e !== "") {
                    setDirtyModal(true)
                  } else {
                    setDirtyModal(false)
                  }
                  if(e.trim() !== "") {
                    setDescriptionWarning(false)
                  } else {
                    setDescriptionWarning(true)
                  }
                  setDescription(e)
                }}
                onKeyUp={(e) => handleKeyUp(e, description)}
              />
              <div className="add-comment__button-container">
                <FlorenzButton
                  typeStyle={"primary"}
                  size="s"
                  text={
                    buttonActive
                      ? t("followUp.commentAndMark")
                      : t("followUp.completed")
                  }
                  widthComplete={false}
                  icon={buttonActive && description && "zaia-i-check-1"}
                  onClick={
                    buttonActive 
                    ? markAsCompleted
                    : null}
                  disabled={buttonActive && description ? false : true}
                />
              </div>
            </div>
          }
        </div>
      }
      {
        changeDateActive &&
        <div className="change-date">
          <div className="remember">{t("followUp.rememberFrequency")}: {t("globally.each")} {frequency(date)}</div>
          <div className="change-date__form">
            <div className="change-date__info">
              <div className="date-container">
                <div className="date-container__title">{t("followUp.previousDate")}</div>
                <div className="date-container__date-box">  
                  <div className="date-container__text">
                    <div className="date-container__date">{P.formatNumberDate(date, true, language)}</div>
                    <div className="date-container__day">{P.nameDayWeek(new Date(date).getDay(), "L", t)}</div>
                  </div>
                </div>
              </div>
              <i className="change-date__icon icon zaia-i-next"></i>
              <div className="date-container">
                <div className="date-container__title">{t("followUp.newDate")}</div>
                <div className="date-container__date-box date-container__date-box--new-date">
                  {/* <i className="date-container__icon zaia-i-time"></i> */}
                  <div className="date-container__text">
                    {/* <div className="date-container__date">January 30th 2024</div> */}
                    <input 
                      className="date-container__date-input" 
                      type="date"
                      value={newDate}
                      onChange={(e) => setNewDate(e.target.value)}
                    />
                    <div className="date-container__day">{P.nameDayWeek(new Date(newDate).getDay() + 1, "L", t)}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="change-date__buttons">
              <button className="button button--cancel" onClick={() => setChangeDateActive(false)}>
                {t("globally.cancel")}
              </button>
              <button className="button button--mark" onClick={() => changeNextUpdate()}>
                {t("globally.save")}
              </button>
            </div>
          </div>
        </div>
      }
    </S.FollowUpCard>
  );
}

export default FollowUp;
